import keyMirror from "key-mirror";

export const AUTH_STATUS = keyMirror({
    UNAUTHORIZED: null,
    AUTHORIZED: null,
    AUTHORIZING: null,
    AUTHORIZATION_FAILED: null,
    VALIDATING_AUTHORIZATION_CREDENTIALS: null,
    INVALID_AUTHORIZATION_CREDENTIALS: null,
    REFRESHING_AUTHORIZATION_CREDENTIALS: null,
    REFRESH_AUTHORIZATION_CREDENTIALS_FAILED: null
});
